<template>
  <div
    ref="rulesModal"
    id="rulesModal"
    class="modal modal-v fade show"
    tabindex="-1"
    role="dialog"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content p-3">
        <div style="box-sizing: border-box; max-width: 793px; margin: 0 auto; padding: 10px 40px; text-align: left;">
          <h1 style="font-size: 23px;">Leitfaden zur Altersfreigabe-Prüfung</h1>
          <p>Bilder, die als sexuell anstößig gelten, müssen sorgfältig überprüft werden. Dabei ist es
            nicht immer eindeutig, ab wann eine Darstellung als explizit anzusehen ist. Klar
            anstößige Bilder, wie die Darstellung von sexuellen Handlungen oder vollständiger
            Nacktheit, lassen jedoch keinen Interpretationsspielraum und sind eindeutig
            unangemessen.
          </p>
          <p>Um sicherzugehen, dass die Richtlinien eingehalten werden, sollte man sich die
            einfache Regel merken: Alles, was man nicht in Anwesenheit von Kindern, Eltern oder
            Vorgesetzten zeigen würde, sollte ebenfalls nicht auf der Plattform zu ﬁnden sein.
          </p>
          <br>
          <h2 style="font-size: 20px;">Grundsätze der Bildprüfung</h2>
          <p>Fragwürdige Inhalte haben keinen Platz in den Nutzerproﬁlen. Bilder, die gegen unsere
            Richtlinien verstoßen, müssen entfernt werden, bevor sie öffentlich sichtbar sind.
            Während der Überprüfung muss stets darauf geachtet werden, dass die Nutzer auf die
            Freigabe ihrer Inhalte warten. Wichtig: Nach jeder Löschung eines Bildes erhält der
            betreffende Nutzer automatisch eine Mitteilung über den Regelverstoß.
          </p>
          <br>
          <h2 style="font-size: 20px;">Beispiele für unerwünschte Inhalte</h2>
          <p>Sexuelle Inhalte: </p>
          <ul>
            <li>Vollständige Nacktheit, einschließlich Genitalien und weiblicher Brustwarzen.</li>
            <li>
              Sexualisierte Posen oder Gesten sowie Bilder, die sexuelle Handlungen
              andeuten.
              <div style="display: flex; flex-wrap: wrap; gap: 30px; margin: 20px 0;">
                <img src="../../../images/verification/image_1.jpg" alt="" style="height: 170px; width: auto;">
                <img src="../../../images/verification/image_2.jpg" alt="" style="height: 170px; width: auto;">
                <img src="../../../images/verification/image_3.jpg" alt="" style="height: 170px; width: auto;">
                <img src="../../../images/verification/image_4.jpg" alt="" style="height: 170px; width: auto;">
              </div>
            </li>
          </ul>
          <br>
          <p>
            Gewalt und illegale Handlungen:
          </p>
          <ul>
            <li>
              Waffen wie Schusswaffen, Messer oder andere gefährliche Objekte.
            </li>
            <li>
              Drogenkonsum, alkoholbedingte Rauschzustände oder der Besitz großer Mengen
              Alkohol.
            </li>
            <li>
              Bilder, die Gewalt, Kampfhandlungen, Vergewaltigung, Tod oder Suizid zeigen.
              <div style="display: flex; flex-wrap: wrap; gap: 12px; margin: 20px 0;">
                <img src="../../../images/verification/image_5.jpg" alt="" style="height: 170px; width: auto;">
                <img src="../../../images/verification/image_6.jpg" alt="" style="height: 170px; width: auto;">
                <img src="../../../images/verification/image_7.jpg" alt="" style="height: 170px; width: auto;">
              </div>
            </li>
          </ul>
          <br>
          <p>
            Inhalte mit Bezug zu Minderjährigen:
          </p>
          <ul>
            <li>Darstellungen von Personen unter 18 Jahren, insbesondere ohne die
              Anwesenheit eines Erwachsenen.
            </li>
            <li>
              Bilder, die Minderjährige in unangenehmen oder potenziell gefährlichen
              Situationen zeigen.
              <div style="display: flex; flex-wrap: wrap; gap: 30px; margin: 20px 0;">
                <img src="../../../images/verification/image_8.jpg" alt="" style="height: 170px; width: auto;">
              </div>
            </li>
          </ul>
          <br>
          <p>Beleidigende oder vulgäre Darstellungen: </p>
          <ul>
            <li>
              Bilder mit obszönen Gesten oder vulgären Ausdrücken.
            </li>
            <li>
              Symbole, die Hass, Diskriminierung oder Belästigung fördern.
              <div style="display: flex; flex-wrap: wrap; gap: 30px; margin: 20px 0;">
                <img src="../../../images/verification/image_9.jpg" alt="" style="height: 170px; width: auto;">
                <img src="../../../images/verification/image_10.jpg" alt="" style="height: 170px; width: auto;">
              </div>
            </li>
          </ul>
          <br>
          <p>
            Unangemessene Textinhalte auf Bildern:
          </p>
          <ul>
            <li>Screenshots privater Unterhaltungen.</li>
            <li>
              Anstößige Nachrichten, sexuelle Vorschläge oder Aufforderungen zu illegalen
              Aktivitäten.
            </li>
            <li>Anregungen zur Selbstverletzung.</li>
          </ul>
          <br>
          <p>Unpassende Kontaktinformationen und Verweise: </p>
          <ul>
            <li>Bilder, die persönliche Kontaktinformationen (z. B. Telefonnummern, Adressen)
              oder externe Links zu anderen Webseiten enthalten.
            </li>
            <li>Fotos, auf denen der vollständige Name des Nutzers zu sehen ist.</li>
          </ul>
          <br>
          <p>Was passiert bei Verstößen?</p>
          <p>Bilder, die gegen diese Richtlinien verstoßen, werden umgehend entfernt. Dazu zählen
            unter anderem auch:
          </p>
          <ul>
            <li>
              Sexualisierte oder illegale Inhalte, die zu einer Handlung auffordern oder
              unangemessene Posen zeigen.
            </li>
            <li>Inhalte, die den Gebrauch von Drogen, Alkohol oder Waffen darstellen.</li>
            <li>
              Symbole oder Darstellungen, die zu Hass oder Diskriminierung aufrufen.
            </li>
          </ul>
          <p>Bei Unsicherheiten ist es besser, ein Bild vorsichtshalber zu entfernen. Zögern Sie nicht,
            bei Unklarheiten Ihren Vorgesetzten um Rat zu fragen.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RuleModal',
  props: {
    isOpened: Boolean,
  },
  data() {
    return {
      // approved: false,
    };
  },
  watch: {
    isOpened: function (val) {
      if (val) {
        this.open();
      }
    }
  },
  methods: {
    open() {
      $(this.$refs.rulesModal).modal('show');
    },
    close() {
      this.$emit('close');
    },
  },
  mounted() {
    let vm = this;

    $(this.$refs.rulesModal).on('hidden.bs.modal', function () {
      vm.close();
    });
  }
};
</script>

<style scoped>
p {
  font-size: 16px;
}
</style>
